export const SPACING_UNIT = 0.5;

export const spacing = (factor: number): string =>
  `${SPACING_UNIT * factor}rem`;

export const spacingScale = {
  xxs: spacing(0.5),
  xs: spacing(1),
  sm: spacing(1.5),
  md: spacing(2),
  lg: spacing(3),
  xl: spacing(4),
  xxl: spacing(6),
} as const;
